import { appendLocaleSources } from '../../hooks/useTranslate'
import VerificationPresenter from '../../api/verificationPresenter'

appendLocaleSources({
  [VerificationPresenter.urn]: {
    page: {
      title: 'Поверка',
    },
    modal: {
      title: {
        create: 'Создание поверки',
        update: 'Обновление поверки',
      },
    },
    action: {
      create: 'Добавить поверку',
    },
    message: {
      confirmDelete: `Вы действительно хотите удалить эту поверку?`,
    },
  },
}, 'ru')

appendLocaleSources({
  [VerificationPresenter.urn]: {
    page: {
      title: 'Verification',
    },
    modal: {
      title: {
        create: 'Create Verification',
        update: 'Update Verification',
      },
    },
    action: {
      create: 'Add Verification',
    },
    message: {
      confirmDelete: `Are you sure you want to delete this verification?`,
    },
  },
}, 'en')

appendLocaleSources({
  [VerificationPresenter.urn]: {
    page: {
      title: 'Tekshirish',
    },
    modal: {
      title: {
        create: 'Tekshirishni yaratish',
        update: 'Tekshirishni yangilash',
      },
    },
    action: {
      create: 'Tekshirishni qoshish',
    },
    message: {
      confirmDelete: `Ushbu tekshiruvni o'chirishni xohlaysizmi?`,
    },
  },
}, 'uz')


